export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiY2RzcGFyY2hlZ2dpbyIsImEiOiJjbTR3OXFtOXgwYWU0MmtxdnduZ3JyNHl1In0.flWPE3WZqWi21oq27MnuHQ';
export const ARCGIS_API_KEY =
  'AAPKabd75694252a4a1885ed1e9daf2c021bnzUEoNoYQafflN6M1AZWT0hk_dHkyPleyOdjBVDSwDoCnX01cNV39nTBWanJHXh-';
